import { Bookmark, CandlestickChart, Menu, Newspaper } from 'lucide-react';
import type { AppTab } from './AppShell.types';

export function BottomNav({ activeTab, onChange }: { activeTab: AppTab; onChange(tab: AppTab): void }) {
  const items = [
    { tab: 'watchlist' as const, label: 'Watchlist', icon: Bookmark },
    { tab: 'chart' as const, label: 'Chart', icon: CandlestickChart },
    { tab: 'news' as const, label: 'News', icon: Newspaper },
    { tab: 'menu' as const, label: 'Menu', icon: Menu },
  ];

  return (
    <nav className="bottom-nav" aria-label="Primary navigation">
      {items.map(({ tab, label, icon: Icon }) => (
        <button
          key={tab}
          type="button"
          className={activeTab === tab ? 'bottom-nav-item active' : 'bottom-nav-item'}
          onClick={() => onChange(tab)}
        >
          <Icon size={28} strokeWidth={1.9} />
          <span className="sr-only">{label}</span>
        </button>
      ))}
    </nav>
  );
}
